/**
 * Explicit confirmation before a pay-as-you-go job the 40-minute minimum applies to (F2, ECTA s 43(2)).
 * The job does not start until the confirm button is pressed; Cancel returns without starting it.
 */
import type { PaygFloorUpload } from '../services/paygFloor';
import { PAYG_FLOOR_CONFIRM_LABEL } from '../services/paygFloor';

export default function PaygFloorConfirm({ notice, onConfirm, onCancel }: { notice: PaygFloorUpload; onConfirm: () => void; onCancel: () => void }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" role="dialog" aria-modal="true" aria-labelledby="payg-floor-confirm-title" data-testid="payg-floor-confirm">
      <div className="w-full max-w-md bg-white rounded-2xl p-6 space-y-3 text-gray-800">
        <h2 id="payg-floor-confirm-title" className="text-lg font-semibold">Confirm the charge</h2>
        {notice.message && <p className="text-sm">{notice.message}</p>}
        {notice.lowBalance && <p className="text-sm">{notice.lowBalance}</p>}
        <div className="flex gap-3 justify-end pt-2">
          <button type="button" onClick={onCancel} className="px-4 py-2 rounded-lg text-sm border border-gray-300 hover:bg-gray-50">Cancel</button>
          <button type="button" onClick={onConfirm} className="px-4 py-2 rounded-lg text-sm font-semibold bg-[#00d4b8] text-[#0d1117] hover:opacity-90">{PAYG_FLOOR_CONFIRM_LABEL}</button>
        </div>
      </div>
    </div>
  );
}
